import { forwardRef } from "react";

// Native links preserve keyboard navigation, new tabs and static Cloudflare routes.
export const Link = forwardRef(function Link(
  { href, children, prefetch, replace, scroll, ...props },
  ref,
) {
  return (
    <a ref={ref} href={href} {...props}>
      {children}
    </a>
  );
});

export function Image({
  src,
  alt,
  priority,
  fill,
  unoptimized,
  quality,
  loader,
  ...props
}) {
  return (
    <img
      src={typeof src === "string" ? src : src.src}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      {...props}
    />
  );
}

export function usePathname() {
  return typeof window === "undefined" ? "/" : window.location.pathname;
}
